import styled from '@emotion/styled';
import { Paragraph6 } from '@nexus/lib-react/dist/core/Typography';
import { Modal } from '@nexus/lib-react/dist/core/Modal/Modal';

const ModalWrapper = styled(Modal)`
  max-width: 552px;
`;

const ButtonLink = styled(Paragraph6)`
  align-self: flex-start;
  padding-top: 6px;
`;

export default {
  ButtonLink,
  ModalWrapper,
};
